import React, {useEffect, useRef} from 'react';


// lines example
// {
//     startX: Number
//     startY: Number
//     endX: Number
//     endY: Number
//     strokeStyle: String
//     lineWidth: Number
// }

const Canvas = ({width = 100, height = 100, background = '#fff', lines = [], names = []}) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef?.current) {
            const canvas = canvasRef.current;
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');

            ctx.fillStyle = background;
            ctx.fillRect(0, 0, canvas.width, canvas.height);


            lines.forEach(line => {
                ctx.strokeStyle = line.strokeStyle;
                ctx.lineWidth = line.lineWidth;
                ctx.beginPath();
                ctx.moveTo(line.startX, line.startY);
                ctx.lineTo(line.endX, line.endY);
                ctx.stroke();
            });

            names.forEach(name => {
                ctx.textAlign = 'center';
                ctx.font = 'bold 30px Arial';
                ctx.fillStyle = '#fff';
                ctx.strokeStyle = '#fff';
                ctx.fillText(name.name, name.x, name.y);
            });


        }
    }, [canvasRef, lines]);


    return <canvas
        ref={canvasRef}
    />;
};

export default Canvas;
